import { OrdinaryObject } from "src/modules/utils/shared/ordinary-object.model";
import { Strings } from "src/modules/utils/shared/strings";

export class ToolTipDefinition {

    component: any;
    data: OrdinaryObject | string;
    onlyWhenClicked = false;

    constructor(component: any, data: OrdinaryObject | string, onlyWhenClicked = false) {
        this.component = component;
        this.data = data;
        this.onlyWhenClicked = onlyWhenClicked;
    }

    getComponentOnHover(): any {
        return this.onlyWhenClicked ? null : this.getSimpleToolTip() ?? this.component;
    }

    getComponentOnClick(): any {
        return this.onlyWhenClicked ? this.getSimpleToolTip() ?? this.component : null;
    }

    getSimpleToolTip(): any {
        return Strings.is(this.data) ? this.data as string : null;
    }

}